import React, { useState, useEffect } from 'react';
import ClippySVG from './ClippySVG';

/**
 * GVC Clippy Mascot - Uses shared ClippySVG component
 */
const BusMascot = ({ size = 120, animated = true, showBubble = true, onClick }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [message, setMessage] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

  const tips = [
    "Don't forget to check driver certifications! 📋",
    "New messages waiting in the Message Board! 📨",
    "All routes running on time today! ✅",
    "Safety first - check your pre-trip inspections! 🔍",
    "ABC School has new training sessions available! 🎓",
    "Click me for quick actions! 👆",
    "Need to page someone? I can help! 📢",
    "Stay safe out there, team! 🚌",
  ];

  // Show tips periodically
  useEffect(() => {
    if (!showBubble) return;
    
    const interval = setInterval(() => {
      const randomTip = tips[Math.floor(Math.random() * tips.length)];
      showMessageFunc(randomTip);
    }, 45000);

    const timeout = setTimeout(() => {
      showMessageFunc("Hi there! I'm Clippers, your GVC assistant! 🤖");
    }, 2000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [showBubble]);

  const showMessageFunc = (text) => {
    setMessage(text);
    setIsAnimating(true);
    
    setTimeout(() => {
      setMessage('');
      setIsAnimating(false);
    }, 6000);
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const greetings = [
        "Need help? Check the Message Board for updates!",
        "You're doing great today! Keep it up! 🌟",
        "Don't forget to acknowledge your messages! ✅",
        "Have a safe and productive day! 🚌",
        "Ready to roll! What can I help with? 🤖",
      ];
      const greeting = greetings[Math.floor(Math.random() * greetings.length)];
      showMessageFunc(greeting);
    }
  };

  if (!isVisible) return null;

  return (
    <div style={showBubble ? styles.container : styles.inlineContainer}>
      {/* Speech Bubble */}
      {showBubble && message && (
        <div style={styles.bubble}>
          <div style={styles.bubbleText}>{message}</div>
          <div style={styles.bubbleArrow} />
        </div>
      )}

      {/* Mascot - Using shared ClippySVG */}
      <div onClick={handleClick} style={{ cursor: 'pointer' }}>
        <ClippySVG size={size} animated={animated} />
      </div>

      {/* Close Button */}
      {showBubble && (
        <button 
          style={styles.closeButton}
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(false);
          }}
          title="Hide assistant"
        >
          ×
        </button>
      )}

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '80px',
    right: '24px',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  inlineContainer: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  bubble: {
    position: 'relative',
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
    padding: '14px 18px',
    borderRadius: '16px',
    marginBottom: '12px',
    maxWidth: '280px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3), 0 0 20px rgba(245, 158, 11, 0.15)',
    animation: 'slideUp 0.3s ease-out',
    border: '2px solid #F59E0B'
  },
  bubbleText: {
    fontSize: '14px',
    color: '#F59E0B',
    lineHeight: '1.4',
    fontWeight: '500'
  },
  bubbleArrow: {
    position: 'absolute',
    bottom: '-10px',
    right: '40px',
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: '10px solid #1a1a1a'
  },
  closeButton: {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    width: '24px',
    height: '24px',
    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    fontWeight: 'bold',
    zIndex: 10
  }
};

export default BusMascot;
